<div class="flex flex-row justify-center items-center space-x-2 pb-6 cursor-pointer">
    <span
        class="text-center text-on-surface text-base font-medium underline underline-offset-2"
        [matMenuTriggerFor]="menu">
        {{ label() | transloco }}
    </span>

    <fa-icon
        class="text-on-surface"
        size="xs"
        [icon]="['fas', 'chevron-down']" />
</div>
<mat-menu
    #menu="matMenu"
    class="max-h-64 overflow-auto justify-center"
    yPosition="below">
    @for (menuOption of menuOptions(); track menuOption) {
        <span mat-menu-item>{{ menuOption }}</span>
    }
</mat-menu>
